import { css, customElement } from "lit";
import CDSMultiSelectItem from "@carbon/web-components/es/components/multi-select/multi-select-item";

class CogMultiSelectItem extends CDSMultiSelectItem {
    static styles = css`
        ${CDSMultiSelectItem.styles}
        .cds--list-box__menu-item__option {
            background-color: #fff;
            border-block-end: 0;
            border-block-start: 0;
            block-size: auto;
        }
        .cds--list-box__menu-item__option {
            background-color: #fff;
            border-block-end: 0;
            border-block-start: 0;
            block-size: auto;
        }
    `;
}
customElements.define("cog-multi-select-item", CogMultiSelectItem);
